// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1UYJ6","title":"styles_title__2Wp6F","nextButton":"styles_nextButton__1NvjB"};